<template>
  <article class="view">
    <header class="view__header" v-if="header">
      <VBlock max-width="111px">
        <img src="@/assets/stars.png" />
      </VBlock>

      <VText center big uppercase>{{ header }}</VText>

      <router-link class="view__back"
        v-if="backButtonTo"
        :to="backButtonTo"
      />
    </header>

    <main class="view__content">
      <slot />
    </main>
  </article>
</template>

<script>
export default {
  name: 'VView',

  props: {
    backButtonTo: {
      type: String,
    },

    header: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.view {
  &__header {
    position: relative;

    margin-top: $gridGutter;
    padding: 0 $gridGutter;

    ::v-deep {
      .text {
        margin-top: 10px;
      }
    }
  }

  &__back {
    position: absolute;

    top: 50%;
    left: $gridGutter;
    width: 50px;
    height: 50px;

    transform: translateY(-50%);

    background-color: #f8c500;
    background-image: url('~@/assets/icon-back.png');
    background-size: 80% auto;
    background-repeat: no-repeat;
    background-position: center center;

    box-shadow: 8px 8px #000000;

    &:hover {
      background-color: #000000;
      background-image: url('~@/assets/icon-back-hover.png');
    }
  }

  &__content {
    padding: $gridGutter;
  }
}
</style>
